<button
  (click)="menuPopover.toggle($event)"
  class="py-2 px-1 hover:bg-gray-50 rounded-lg transition-colors"
  aria-label="Menu"
>
  <img src="assets/icons/menu.png" alt="Menu" class="w-6 h-6 object-contain" />
</button>

<p-popover #menuPopover styleClass="pra-menu-popover">
  <div class="flex flex-col p-4 md:p-1 h-full overflow-y-auto">
    <!-- Header -->
    <div class="flex items-center justify-between mb-4">
      <h2 class="text-[24px] font-bold text-[#192A3E]">Menu</h2>
      <button
        (click)="menuPopover.hide()"
        class="p-1 hover:bg-gray-100 rounded-lg transition-colors"
        aria-label="Close"
      >
        <img src="assets/icons/close.svg" alt="Close" class="w-8 h-8 object-contain" />
      </button>
    </div>

    <!-- About You Section -->
    <div class="mb-4">
      <h3 class="text-[18px] font-bold text-[#192A3E] mb-3">About You</h3>
      <div class="grid grid-cols-3 md:grid-cols-4 gap-3">
        @for (item of menuSections.aboutYou; track item.label) {
        <button
          (click)="onMenuItemClick(item)"
          class="flex flex-col items-center  p-3 bg-[#F2F6F8] hover:bg-[#E5EEF2] rounded-[8px] transition-colors"
        >
          <div class="w-12 h-12  flex items-center justify-center">
            <img [src]="item.icon" [alt]="item.label" class="w-full h-full object-contain" />
          </div>
          <span class="text-[13px] font-medium text-[#192A3E] text-center leading-tight">{{
            item.label
          }}</span>
        </button>
        }
      </div>
    </div>

    <!-- Portfolio Section -->
    <!-- <div class="mb-4">
      <h3 class="text-[18px] font-bold text-[#192A3E] mb-3">Portfolio</h3>
      <div class="grid grid-cols-3 md:grid-cols-4 gap-3">
        @for (item of menuSections.portfolio; track item.label) {
        <button
          (click)="onMenuItemClick(item)"
          class="flex flex-col items-center justify-center p-3 bg-[#F2F6F8] hover:bg-[#E5EEF2] rounded-[8px] transition-colors"
        >
          <div class="w-12 h-12 mb-2 flex items-center justify-center">
            <img [src]="item.icon" [alt]="item.label" class="w-full h-full object-contain" />
          </div>
          <span class="text-[13px] font-medium text-[#192A3E] text-center leading-tight">{{
            item.label
          }}</span>
        </button>
        }
      </div>
    </div> -->

    <!-- Others Section -->
    <div>
      <h3 class="text-[18px] font-bold text-[#192A3E] mb-3">Others</h3>
      <div class="grid grid-cols-3 md:grid-cols-4 gap-3">
        @for (item of menuSections.others; track item.label) {
          @if (item.label === 'Help') {
            <button
              (click)="helpPopover.toggle($event)"
              class="flex flex-col items-center p-3 bg-[#F2F6F8] hover:bg-[#E5EEF2] rounded-[8px] transition-colors"
            >
              <div class="w-12 h-12 flex items-center justify-center">
                <img [src]="item.icon" [alt]="item.label" class="w-full h-full object-contain" />
              </div>
              <span class="text-[13px] font-medium text-[#192A3E] text-center leading-tight">{{ item.label }}</span>
            </button>
          } @else {
            <button
              (click)="onMenuItemClick(item)"
              class="flex flex-col items-center p-3 bg-[#F2F6F8] hover:bg-[#E5EEF2] rounded-[8px] transition-colors"
            >
              <div class="w-12 h-12 flex items-center justify-center">
                <img [src]="item.icon" [alt]="item.label" class="w-full h-full object-contain" />
              </div>
              <span class="text-[13px] font-medium text-[#192A3E] text-center leading-tight">{{ item.label }}</span>
            </button>
          }
        }
      </div>
    </div>
  </div>
</p-popover>

<p-popover #helpPopover>
  <div class="flex flex-col py-1 min-w-[220px]">
    <button type="button"
      class="flex items-center gap-3 px-4 py-3 hover:bg-[#F2F6F8] transition-colors text-left cursor-pointer border-none bg-transparent w-full rounded-[6px]"
      (click)="contactSupport()">
      <i class="pi pi-envelope text-[#238EC6] text-[16px]"></i>
      <span class="text-[14px] font-medium text-[#192A3E]">Contact customer support</span>
    </button>
  </div>
</p-popover>

@if(DeletePopupVisible()){
  <pa-account-deletion-dialog (closed)="DeletePopupVisible.set(false)" />
}